export enum PATHS {
  signUp = '/sign-up',
  login = '/login',
  main = '/',
  courses = '/courses',
  course = '/courses/:groupId/*',
  lesson = '/courses/:groupId/:lessonId/*',
  lessonDescription = 'lessonDescription',
  lessonStudentAttachments = 'lessonAttachments/student',
  lessonTeacherAttachments = 'lessonAttachments/teacher',
  lessonStudentResources = 'lessonResources/student',
  lessonJournal = 'lessonJournal',
  lessonTasks = 'lessonTasks',
  lessonResults = 'lessonResults',
  lessonFinalTest = 'lessonFinalTest',
  resume = '/resume',
  invoices = '/invoices',
  attachments = '/attachments',
  attachment = '/attachments/:type/:fileId/*',
  homework = 'homework',
  coursework = 'coursework',
  graduationProject = 'graduationProject',
}
